// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1g0WQ","footer":"ReportModalFilter_footer__31eaA"};